<template>
  <teleport to="body">
    <div @click="dialogVisible = false" class="dialog-box" v-if="dialogVisible">
      <div @click.stop="" class="dialog-contnet">
        <h2>{{ $t("dialog.text7") }}</h2>

        <h4 v-if="language === 'zh'">
          {{ $t("dialog.text8") }}
        </h4>

        <ul>
          <li>
            <el-icon size="12px" color="#9038FF"><CircleCheckFilled /></el-icon>
            <span>{{ $t("dialog.text9") }}</span>
          </li>
          <li>
            <el-icon size="12px" color="#9038FF"><CircleCheckFilled /></el-icon>
            <span>{{ $t("dialog.text10") }}</span>
          </li>
          <li>
            <el-icon size="12px" color="#9038FF"><CircleCheckFilled /></el-icon>
            <span>{{ $t("dialog.text11") }}</span>
          </li>
        </ul>

        <div class="button">
          <div @click.stop="dialogVisible = false" class="btn1 btn">
            {{ $t("dialog.text12") }}
          </div>
          <div @click.stop="handleOpen" class="btn2 btn">{{ $t("dialog.text13") }}</div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { CircleCheckFilled } from "@element-plus/icons-vue";
import { useGetLanguage } from "@/hooks/useGetLanguage";

const dialogVisible = defineModel();

const { contactUrl, contactAddress, language } = useGetLanguage();

function preventScroll(e: any) {
  e.preventDefault();
  e.stopPropagation();
  return false;
}

function handleOpen() {
  window.open(contactAddress.value);
  dialogVisible.value = false;
}

watch(
  dialogVisible,
  (val) => {
    if (val) {
      document.addEventListener("wheel", preventScroll, { passive: false });
    } else {
      document.removeEventListener("wheel", preventScroll);
    }
  },
  {
    immediate: true,
  }
);
</script>

<style scoped lang="scss">
.dialog-box {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .dialog-contnet {
    width: 532px;
    background-color: #fff;
    border-radius: 16px 16px 16px 16px;
    padding: 36px;

    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #000000;
      text-align: left;
    }
    h4 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #435267;
    }

    ul {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #9038ff;
      margin-top: 40px;
      margin-bottom: 24px;
      width: max-content;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        span {
          margin-left: 6px;
        }
      }
    }

    .button {
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-weight: 500;
      font-size: 24px;
      transition: all 0.3s;
      cursor: pointer;
      margin-top: 40px;

      .btn {
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #9038ff;
        padding: 6px 24px;
        margin-left: 20px;
      }

      .btn2 {
        background: #7815f5;
        color: #fff;
      }
    }
  }
}
</style>
